<template lang="html">
  <v-list two-line avatar style="max-height: calc(100vh - 50px - 8px - 8px - 25px - 80px); overflow: auto">
    <v-list-item
      v-for="(invitation, index) in project_invitations"
      :key="`${index}update${update_index}`"
      >
      <v-list-item-avatar :color="getInvitationStatusColor(invitation.status)" small>
        <v-icon>{{getInvitationStatusIcon(invitation.status)}}</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-row>
          <v-col cols="4">
            <v-list-item-title>{{invitation.email}}</v-list-item-title>
            <v-list-item-subtitle>{{invitation.prole}}</v-list-item-subtitle>
          </v-col>
          <v-col cols="7">
            <div class="wp-list">
              <TWorkPackage
              v-for="wp in invitation.work_packages"
              :key="`invitedwp${wp.id}`"
              :workpackage_count="1"
              :workpackage="wp"
              :color="wp.color"
              >
              <template #workpackage>
                <StandardBadge
                :text="wp.count"
                color="white"
                content_color="black"
                />
              </template>
            </TWorkPackage>
          </div>
          </v-col>
          <v-col cols="1">
            <StandardDeleteBtn
              v-if="hasProjectPermission({project_id: project_id, ppermission: 'Update Invites'})"
              :btnclass="'pull-right'"
              :el="invitation"
              @deleteClick="deleteProjectInvite(invitation).then(() => {
                  update_index++
                })"
            />
          </v-col>
        </v-row>
      </v-list-item-content>
    </v-list-item>
    <template v-if="hasProjectPermission({project_id: project_id, ppermission: 'Add Invites'})">
      <v-list-item v-show="!add_invite" @click="add_invite = true">
        <v-list-item-avatar color="grey" small>
          <v-icon>add</v-icon>
        </v-list-item-avatar>
        <TText value="Invite_User_to_Project" font_weight="400"/>
      </v-list-item>
      <v-list-item v-show="this.add_invite">
        <v-row>
          <v-col cols="1">
            <v-list-item-avatar color="grey" small>
              <v-icon>add</v-icon>
            </v-list-item-avatar>
          </v-col>
          <v-col cols="6">
            <v-list-item-content>
              <StandardTextfield
                color="grey darken-1"
                textcolor="white"
                :placeholder="$t('Project.Settings.Members.Invites.EmailAddress')"
                :value="getNewInvite.email"
                @changeValue="setNewInviteEmail($event)"
                style="width: 90%"
                />
            </v-list-item-content>
          </v-col>
          <v-col cols="2">
            <v-list-item-content>
              <StandardDropdown
                :value="getNewInvite.prole !== ''? getNewInvite.prole.name:'select Role'"
                color="grey darken-1"
                :options="project_proles"
                @changeValue="setNewInvitePRole($event)"
              />
            </v-list-item-content>
          </v-col>
          <v-col cols="1">
            <v-list-item-content>
              <TIconButton
                icon="company"
                :color="'white'"
                tooltip="Add to company"
                @clickIcon="setAddToCompany()"
              />
              <ToggleCapsule
                :is_active="$store.state.ProjectInvitation.new_invitation.add_to_company"
                background_color="white"
                foreground_color="green"
                knob_color="grey darken-2"
                border_color="grey darken-2"
                @toggleClicked="setAddToCompany()"
              />
            </v-list-item-content>
          </v-col>
          <v-col cols="2">
            <v-list-item-action class="ma-0">
              <v-btn color="red" icon @click="cancelAddInvitation()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-list-item-action>
            <v-list-item-action class="ma-0">
              <v-btn color="green" icon
              :disabled="isDisabled"
              @click="sendInvitation()">
                <v-icon>send</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-col>
        </v-row>
      </v-list-item>
      <v-list-item v-if="this.add_invite">
        <v-row>
          <v-col>
            <v-btn color="primary" text @click="$router.push({
                name: 'ProjectInviteWPSelectTaktPlan',
                params: {
                  project_id: $route.params.project_id,
                }
              })">{{$t('Project.Settings.Members.Invites.SelectWPButton')}}</v-btn>
          </v-col>
          <v-col>
            <div class="wp-list">
              <TWorkPackage
                v-for="wps in getInviteSelectedWPs"
                :key="`selectedwp${wps[0].id}`"
                :workpackage_count="1"
                :workpackage="wps[0]"
                :color="wps[0].color"
              >
              <template #default>
                <StandardBadge
                  class="cursor-pointer"
                  :text="wps.length"
                  color="white"
                  content_color="black"
                />
                </template>
              </TWorkPackage>
            </div>
          </v-col>
        </v-row>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
import { TWorkPackageMixin } from '@/mixins/TWorkPackage.mixin.js'
import StandardTextfield from '@/components/StandardComponents/StandardTextfield.component.vue'
import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue'
import StandardDropdown from '@/components/StandardComponents/StandardDropdown.component.vue'
import StandardDeleteBtn from '@/components/StandardComponents/StandardDeleteBtn.component.vue'
import TText from '@/components/Taktify/TText.component.vue'
import TIconButton from '@/components/Taktify/TIconButton.component.vue'
import ToggleCapsule from '@/components/WorkPackageWIP/ToggleCapsule.component.vue'

import {
  mapActions,
  mapGetters
} from 'vuex';
export default {
  components: {
    StandardTextfield,
    StandardDropdown,
    StandardBadge,
    StandardDeleteBtn,
    TText,
    TIconButton,
    ToggleCapsule
  },
  mixins: [TWorkPackageMixin],
  props: ['project_invitations', 'project_proles', 'project_id'],
  data: () => ({
    add_invite: false,
    send_disabled: true,
    update_index: 0,
  }),
  created(){
    if (this.$route.query.role === 'Craftsman') {
      this.add_invite = true;
    }
  },
  computed: {
    ...mapGetters('ProjectInvitation', [
      'getInviteSelectedWPs',
      'getNewInvite',
    ]),
    ...mapGetters('Project', [
      'hasProjectPermission',
    ]),
    isDisabled: function(){
      if (this.getNewInvite.email === '' || this.getNewInvite.prole.name === '') {
        return true;
      }
      if (!this.validateEmail(this.getNewInvite.email)) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions('ProjectInvitation', [
      'sendProjectInvitation',
      'setNewInviteEmail',
      'setNewInvitePRole',
      'setAddToCompany',
      'resetNewInvite',
      'deleteProjectInvite'
    ]),
    validateEmail(email){
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    cancelAddInvitation() {
      this.resetNewInvite();
      this.add_invite = false;
    },
    sendInvitation() {
      let invite = {
        email: this.getNewInvite.email,
        prole: this.getNewInvite.prole.id,
        add_to_company: this.getNewInvite.add_to_company,
        
      };
      if(this.getNewInvite.add_to_company){
        invite.business_id = this.$store.state.Auth.current_user.business.id
      }

      invite.work_packages = [];
      for (var key in this.getInviteSelectedWPs) {
        for (var i = 0; i < this.getInviteSelectedWPs[key].length; i++) {
          invite.work_packages.push({
            id: this.getInviteSelectedWPs[key][i].id
          });
        }
      }
      
      this.sendProjectInvitation({
        project_id: this.$route.params.project_id,
        invitation: invite
      });
    },
    getInvitationStatusIcon(status) {
      switch (status) {
        case 'user_registration':
          return "assignment_ind";
        case 'takting_approval':
          return "assignment";
        case 'user_accepting':
          return "hourglass_empty";
        case 'takting_rejected':
          return "assignment_late";
        case 'user_rejected':
          return "assignment_late";
      }
    },
    getInvitationStatusColor(status) {
      switch (status) {
        case 'user_registration':
          return "orange";
        case 'takting_approval':
          return "orange";
        case 'user_accepting':
          return "orange";
        case 'takting_rejected':
          return "red";
        case 'user_rejected':
          return "red";
      }
      // ...mapActions('View', [
      //   'setProjectMembersSelectedIndex'
      // ])
    }
  }
}
</script>

<style lang="css" scoped>
.wp-list{
  display: flex;
  overflow-x: auto;
  /* width: 400px; */
  /* max-width: 500px; */
  flex-shrink: 0;
}
</style>
